import _ from 'lodash';

import { Typography } from 'omakase';

interface Props {
  /**
   * The name of the section. Required.
   */
  name: string | JSX.Element;

  /**
   * An action element to display in the top right. Optional
   */
  action?: JSX.Element;
}

/**
 * Generic section component that represents the profile section name.
 */
const ProfileSectionTitle = ({ name, action }: Props) => {
  return (
    <div className="Profile-sectionTitle">
      <div className="Profile-sectionItem">
        {_.isString(name) ? (
          <Typography component="h2" variant="heading02">
            {name}
          </Typography>
        ) : (
          name
        )}
      </div>
      {action && <div className="Profile-sectionTitle-action Profile-sectionItem">{action}</div>}
    </div>
  );
};

export default ProfileSectionTitle;
